import {createAsyncThunk, createSlice, PayloadAction} from '@reduxjs/toolkit'
import {
  fetchCreateProductApi,
  fetchPackageListApi,
  fetchProductListApi,
  fetchUpdateProductApi,
  ListPackageResponse,
  fetchUpdateStatusApi,
  PackageListRequest,
  ProductManagementSearchRequest,
  fetchProductAvailableApi,
  ProductAvailableType,
  OfferItemsType,
  PricesInterface,
  fetchProductInquiryApi,
  fetchDetailProduct,
  ProductManagementParam,
  fetchActiveLicenses,
  ActiveLicenses,
  ProductPurchaseHistoryPayload,
  fetProductPurchaseHistory,
  ProductPurchaseHistoryResponse,
  AdminProductParamResponse,
  fetchListProductHistoryOrganizationApi,
  ProductInquiryType,
  ProductPurchaseHistoryOrganizationPayload,
  getAvailableLicenseItems,
  AvailableLicenses,
  ListProductType,
  ListProductPagingResponse,
  ProductManagementSearchPagingRequest,
  fetchProductListPagingApi,
  updateDisplayInfoProductApi,
  DisplayInfosType,
} from 'api/productApi'
import {
  OFFER_TYPE,
  PAYMENT_METHOD,
  PaymentMethod,
  SaleStatus,
  TYPE_INDICATOR_PRODUCT,
} from 'pages/ProductsPages/constant'

import {RootState} from 'store'

export const getProductPurchaseHistory = createAsyncThunk(
  'product/productPurchaseHistory',
  async (payload: ProductPurchaseHistoryPayload, {rejectWithValue}) => {
    try {
      const response = await fetProductPurchaseHistory(payload)
      return response.data
    } catch (err) {
      return rejectWithValue(err.message)
    }
  },
)

export const getListActiveLicenses = createAsyncThunk(
  'product/listActiveLicenses',
  async (_, {rejectWithValue}) => {
    try {
      const response = await fetchActiveLicenses()
      return response.data
    } catch (err) {
      return rejectWithValue(err.message)
    }
  },
)

export const getDetailProduct = createAsyncThunk(
  'product/listDetailProduct',
  async (id: string, {rejectWithValue}) => {
    try {
      const response = await fetchDetailProduct(id)
      return response.data
    } catch (err) {
      return rejectWithValue(err.message)
    }
  },
)

export const getListProductInquiry = createAsyncThunk(
  'product/listProductInquiry',
  async (_, {rejectWithValue}) => {
    try {
      const response = await fetchProductInquiryApi()
      return response.data
    } catch (err) {
      return rejectWithValue(err.message)
    }
  },
)

export const getListProductAvailable = createAsyncThunk(
  'product/listProductAvailable',
  async (_, {rejectWithValue}) => {
    try {
      const response = await fetchProductAvailableApi()
      return response.data
    } catch (err) {
      return rejectWithValue(err.message)
    }
  },
)

export const getPackageItem = createAsyncThunk(
  'product/listProduct',
  async (payload: PackageListRequest, {rejectWithValue}) => {
    try {
      const response = await fetchPackageListApi(payload)
      return response.data
    } catch (err) {
      return rejectWithValue(err.message)
    }
  },
)

export const getAllPackageItem = createAsyncThunk(
  'product/allListProduct',
  async (_, {rejectWithValue}) => {
    try {
      const response = await fetchPackageListApi({
        target: TYPE_INDICATOR_PRODUCT.ALL,
      })
      return response.data
    } catch (err) {
      return rejectWithValue(err.message)
    }
  },
)

export const getListProduct = createAsyncThunk(
  'product/listPackage',
  async (payload: ProductManagementSearchRequest, {rejectWithValue}) => {
    try {
      const response = await fetchProductListApi(payload)
      return response.data
    } catch (err) {
      return rejectWithValue(err.message)
    }
  },
)

export const getListProductPaging = createAsyncThunk(
  'product/listPackagePaging',
  async (payload: ProductManagementSearchPagingRequest, {rejectWithValue}) => {
    try {
      const response = await fetchProductListPagingApi(payload)
      return response.data
    } catch (err) {
      return rejectWithValue(err.message)
    }
  },
)

export const updateStatus = createAsyncThunk(
  'product/status',
  async (payload: {goodsId: string; status: SaleStatus}, {rejectWithValue}) => {
    try {
      const response = await fetchUpdateStatusApi(payload)
      return response.data
    } catch (err) {
      return rejectWithValue(err?.message)
    }
  },
)

export const handleCreateProduct = createAsyncThunk(
  'product/createProduct',
  async (payload: AdminProductParamResponse, {rejectWithValue}) => {
    try {
      const response = await fetchCreateProductApi(payload)
      return response.data
    } catch (err) {
      return rejectWithValue(err.message)
    }
  },
)

export const handleUpdateProduct = createAsyncThunk(
  'product/updateProduct',
  async (
    payload: {data: AdminProductParamResponse; goodsId: string},
    {rejectWithValue},
  ) => {
    try {
      const response = await fetchUpdateProductApi(payload)
      return response.data
    } catch (err) {
      return rejectWithValue(err.message)
    }
  },
)

export const handleUpdateDisplayInfoProduct = createAsyncThunk(
  'product/updateDisplayInfoProduct',
  async (
    payload: {displayInfos: DisplayInfosType[]; goodsId: string},
    {rejectWithValue},
  ) => {
    try {
      const response = await updateDisplayInfoProductApi(payload)
      return response.data
    } catch (err) {
      return rejectWithValue(err.message)
    }
  },
)

export const handleGetProductHistoryOrganization = createAsyncThunk(
  'product/getProductHistoryOrganization',
  async (
    query: ProductPurchaseHistoryOrganizationPayload,
    {rejectWithValue},
  ) => {
    try {
      const response = await fetchListProductHistoryOrganizationApi(query)
      return response.data
    } catch (err) {
      return rejectWithValue(err.message)
    }
  },
)

export const fetchAvailableLicenses = createAsyncThunk(
  'licenses/v1/user/license/usable-items',
  async (_, {rejectWithValue}) => {
    try {
      const response = await getAvailableLicenseItems()
      return response.data
    } catch (err) {
      return rejectWithValue(err?.message)
    }
  },
)

export interface PurchaseDataType {
  product: {
    goodsId: string
    goodsName: string[]
    totalAmount: number
    sale: {
      salePrice: PricesInterface[]
      paymentMethod: PaymentMethod
    }
    offer: {
      usagePeriodUnit: string
      offerItems: OfferItemsType[]
      offerType: string
      usagePeriod: number
    }
  }
}
interface ProductManagementState {
  query: ProductManagementParam
  loading: boolean
  listProductAvailableLoading: boolean
  listProductInquiryLoading: boolean
  error: unknown
  listProductResponse: ListProductType[] | null
  listProductPaging: ListProductPagingResponse
  listPackage: ListPackageResponse[] | null
  listAllPackage: ListPackageResponse[] | null
  listProductAvailable: ProductAvailableType[] | null
  purchaseData: PurchaseDataType
  listProductInquiry: ActiveLicenses[] | null
  listProductPurchaseHistory: ProductPurchaseHistoryResponse[] | []
  listProductPurchaseHistoryOrganization: ProductInquiryType | null
  listAvailableLicenses: AvailableLicenses[]
  isAgreeToPurchase: boolean
}

const initialState: ProductManagementState = {
  loading: false,
  listProductAvailableLoading: false,
  listProductInquiryLoading: false,
  query: {
    page: 0,
    size: 10,
    targets: '',
    paymentMethod: '',
    goodsName: null,
  },
  error: undefined,
  listProductResponse: null,
  listProductInquiry: null,
  listPackage: null,
  listAllPackage: null,
  listProductAvailable: null,
  purchaseData: {
    product: {
      goodsId: '',
      goodsName: [],
      totalAmount: 0,
      sale: {
        salePrice: [],
        paymentMethod: PAYMENT_METHOD.MANUAL,
      },
      offer: {
        usagePeriodUnit: 'MONTH',
        offerType: OFFER_TYPE.MONTHLY,
        offerItems: [
          {
            offerUnit: 'count',
            offerAmount: 1000,
            unitPrices: [
              {currency: 'KRW', price: 2200},
              {currency: 'USD', price: 2.5},
            ],
            pkgItemId: 'pkg-1234',
          },
          {
            offerUnit: 'count',
            offerAmount: 1500,
            unitPrices: [
              {currency: 'KRW', price: 1800},
              {currency: 'USD', price: 1.8},
            ],
            pkgItemId: 'pkg-5678',
          },
        ],
        usagePeriod: 0,
      },
    },
  },
  listProductPurchaseHistory: [],
  listProductPurchaseHistoryOrganization: null,
  listAvailableLicenses: [],
  listProductPaging: {
    content: [],
    totalElements: 0,
    totalPages: 0,
    size: 0,
    number: 0,
  },
  isAgreeToPurchase: false,
}

export const productManagementSlice = createSlice({
  name: 'product',
  initialState,
  reducers: {
    changeQuerySearch: <K extends keyof ProductManagementParam>(
      state: ProductManagementState,
      action: PayloadAction<{key: K; value: ProductManagementParam[K]}>,
    ) => {
      state.query[action.payload.key] = action.payload.value
    },
    setPurchaseData: (
      state: ProductManagementState,
      action: PayloadAction<PurchaseDataType>,
    ) => {
      const {product} = action.payload
      if (!product) {
        throw new Error('Product and user data must be provided')
      }
      state.purchaseData.product = product
    },
    setIsAgreeToPurchase: (
      state: ProductManagementState,
      action: PayloadAction<boolean>,
    ) => {
      state.isAgreeToPurchase = action.payload
    },
  },
  extraReducers: (builder) => {
    builder.addCase(getListProduct.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(getListProduct.fulfilled, (state, action) => {
      state.listProductResponse = action.payload
      state.loading = false
    })
    builder.addCase(getListProduct.rejected, (state, action) => {
      state.loading = false
      state.error = action.payload
    })

    builder.addCase(getListProductPaging.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(getListProductPaging.fulfilled, (state, action) => {
      state.listProductPaging = action.payload
      state.loading = false
    })
    builder.addCase(getListProductPaging.rejected, (state, action) => {
      state.loading = false
      state.error = action.payload
    })

    builder.addCase(handleCreateProduct.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(handleCreateProduct.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(handleCreateProduct.rejected, (state, action) => {
      state.loading = false
      state.error = action.payload
    })

    builder.addCase(handleUpdateProduct.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(handleUpdateProduct.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(handleUpdateProduct.rejected, (state, action) => {
      state.loading = false
      state.error = action.payload
    })

    builder.addCase(handleUpdateDisplayInfoProduct.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(handleUpdateDisplayInfoProduct.fulfilled, (state) => {
      state.loading = false
    })
    builder.addCase(
      handleUpdateDisplayInfoProduct.rejected,
      (state, action) => {
        state.loading = false
        state.error = action.payload
      },
    )

    builder.addCase(getPackageItem.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(getPackageItem.fulfilled, (state, action) => {
      state.listPackage = action.payload
      state.loading = false
    })
    builder.addCase(getPackageItem.rejected, (state, action) => {
      state.loading = false
      state.error = action.payload
    })

    builder.addCase(getAllPackageItem.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(getAllPackageItem.fulfilled, (state, action) => {
      state.listAllPackage = action.payload
      state.loading = false
    })
    builder.addCase(getAllPackageItem.rejected, (state, action) => {
      state.loading = false
      state.error = action.payload
    })

    builder.addCase(getListProductAvailable.pending, (state) => {
      state.listProductAvailableLoading = true
      state.error = null
    })
    builder.addCase(getListProductAvailable.fulfilled, (state, action) => {
      state.listProductAvailableLoading = false
      state.listProductAvailable = action.payload
    })
    builder.addCase(getListProductAvailable.rejected, (state, action) => {
      state.listProductAvailableLoading = false
      state.error = action.payload
    })

    builder.addCase(getListProductInquiry.pending, (state) => {
      state.listProductInquiryLoading = true
      state.error = null
    })
    builder.addCase(getListProductInquiry.fulfilled, (state, action) => {
      state.listProductInquiry = action.payload
      state.listProductInquiryLoading = false
    })
    builder.addCase(getListProductInquiry.rejected, (state, action) => {
      state.listProductInquiryLoading = false
      state.error = action.payload
    })

    builder.addCase(getProductPurchaseHistory.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(getProductPurchaseHistory.fulfilled, (state, action) => {
      state.listProductPurchaseHistory = action.payload
      state.loading = false
    })
    builder.addCase(getProductPurchaseHistory.rejected, (state, action) => {
      state.loading = false
      state.error = action.payload
      state.listProductPurchaseHistory = []
    })
    builder.addCase(handleGetProductHistoryOrganization.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(
      handleGetProductHistoryOrganization.fulfilled,
      (state, action) => {
        state.listProductPurchaseHistoryOrganization = action.payload
        state.loading = false
      },
    )
    builder.addCase(handleGetProductHistoryOrganization.rejected, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchAvailableLicenses.pending, (state) => {
      state.loading = true
      state.error = null
    })
    builder.addCase(fetchAvailableLicenses.fulfilled, (state, action) => {
      state.listAvailableLicenses = action.payload
      state.loading = false
    })
    builder.addCase(fetchAvailableLicenses.rejected, (state) => {
      state.loading = true
      state.error = null
    })
  },
})
export const {changeQuerySearch, setPurchaseData, setIsAgreeToPurchase} =
  productManagementSlice.actions

export default productManagementSlice.reducer

export const selectLoading = (state: RootState) =>
  state.productManagement.loading

export const selectListProductAvailableLoading = (state: RootState) =>
  state.productManagement.listProductAvailableLoading

export const selectListProductInquiryLoading = (state: RootState) =>
  state.productManagement.listProductInquiryLoading

export const selectQuery = (state: RootState) => ({
  page: state.productManagement.query.page,
  size: state.productManagement.query.size,
  targets: state.productManagement.query.targets,
  paymentMethod: state.productManagement.query.paymentMethod,
  goodsName: state.productManagement.query.goodsName,
})
export const selectListProductResponse = (state: RootState) =>
  state.productManagement.listProductResponse

export const selectListProductPaging = (state: RootState) =>
  state.productManagement.listProductPaging

export const selectListPackage = (state: RootState) =>
  state.productManagement.listPackage

export const selectListAllPackage = (state: RootState) =>
  state.productManagement.listAllPackage

export const selectListProductAvailable = (state: RootState) =>
  state.productManagement.listProductAvailable

export const selectPurchaseData = (state: RootState) =>
  state.productManagement.purchaseData

export const selectProductInquiry = (state: RootState) =>
  state.productManagement.listProductInquiry

export const selectListProductPurchaseHistory = (state: RootState) =>
  state.productManagement.listProductPurchaseHistory

export const selectListProductPurchaseHistoryOrganization = (
  state: RootState,
) => state.productManagement.listProductPurchaseHistoryOrganization

export const selectListAvailableLicenses = (state: RootState) =>
  state.productManagement.listAvailableLicenses

export const selectIsAgreeToPurchase = (state: RootState) =>
  state.productManagement.isAgreeToPurchase
